var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckoutCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#D2FDD4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1151_14412)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4193 13.7474H29.3359C30.3443 13.7474 31.1693 14.5724 31.1693 15.5807V22.7369C30.6417 22.2307 30.0212 21.8206 29.3359 21.5348V18.3307H14.6693V30.2474H22.0243C22.4976 30.9858 23.1293 31.6129 23.8715 32.0807H14.6693C13.6609 32.0807 12.8359 31.2557 12.8359 30.2474V15.5807C12.8359 14.5724 13.6609 13.7474 14.6693 13.7474H15.5859V11.9141H17.4193V13.7474H26.5859V11.9141H28.4193V13.7474Z",
    fill: "#07213C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4928 22.9141C24.9628 22.9141 22.9141 24.9674 22.9141 27.4974C22.9141 30.0274 24.9628 32.0807 27.4928 32.0807C30.0274 32.0807 32.0807 30.0274 32.0807 27.4974C32.0807 24.9674 30.0274 22.9141 27.4928 22.9141ZM27.4974 31.1641C25.4716 31.1641 23.8307 29.5232 23.8307 27.4974C23.8307 25.4716 25.4716 23.8307 27.4974 23.8307C29.5232 23.8307 31.1641 25.4716 31.1641 27.4974C31.1641 29.5232 29.5232 31.1641 27.4974 31.1641Z",
    fill: "#07213C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6771 25.5547H27.2188V27.9591L28.8229 29.2214L29.0521 28.7285L27.6771 27.6585V25.5547Z",
    fill: "#07213C"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckoutCalendarIcon);
export default __webpack_public_path__ + "static/media/checkout-calendar-icon.28ce201aa19e09dd26e7e88899bcfd1e.svg";
export { ForwardRef as ReactComponent };